import { NumberChoiceModel, StringChoiceModel } from "models/ChoiceModel";
import { createContext } from "react";

export interface EnumChoicesContextProps {
  addAgendaItemPositions: NumberChoiceModel[];
  boardStatuses: NumberChoiceModel[];
  meetingStatuses: NumberChoiceModel[];
  agendaItemStatuses: NumberChoiceModel[];
  taskStatuses: NumberChoiceModel[];
  participantStatuses: NumberChoiceModel[];
  participantRoles: StringChoiceModel[];
}

export const EnumChoicesContext = createContext({} as EnumChoicesContextProps);
